import React from 'react'
import { BlockCommonLayout } from '../../utils/layout'
import { Flex, Icon, Text } from '@capioweb/ui-components/src'
import { scale } from '@capioweb/ui-components'
import { StringProperty } from '../../@types/EpiFoundationSpa/Property'
import styled from 'styled-components'

interface Item {
    name: string
    isPro: boolean
    isCon: boolean
}

interface ProsAndConsBlockProps {
    items: Item[]
    heading: StringProperty
    preamble: StringProperty
    firstColumnHeading: StringProperty
    secondColumnHeading: StringProperty
    thirdColumnHeading: StringProperty
    screenReaderTextColumn1: StringProperty
    screenReaderTextColumn2: StringProperty
}
interface StyledTableHeaderProps {
    scope: string
}

const StyledTableCell = styled.td`
display: flex;
width: 100%;
max-width: ${scale.px(11)};
justify-content: center;
text-align: center;
`
const StyledTableHeader = styled.th.attrs((props: StyledTableHeaderProps) => ({
    scope: props.scope,
    ariaHidden: true
})) <StyledTableHeaderProps>`
display: flex;
width: 100%;
max-width: ${scale.px(11)};
justify-content: center;
text-align: center;
`

const ProsAndConsBlock: React.FC<ProsAndConsBlockProps> = (props) => {
    const hasColumnTitles = props.firstColumnHeading?.value || props.secondColumnHeading?.value || props.thirdColumnHeading?.value
    return (
        <BlockCommonLayout heading={props.heading} description={props.preamble}>
            <Flex as="table" mx='auto' w={1} maxw={69} flexDirection='column'>
                <Flex className='visually-hidden' as="caption">{props.preamble.value}</Flex>
                {hasColumnTitles &&
                    <Flex
                        as="tr"
                        w={1}
                        px={1}
                        pt={{ m: 1 }}
                        pb={2}
                        justifyContent='space-between'
                    >
                        <Flex as="th" scope="col" w={1}>
                            <Flex w={1} maxw={{ _: 25, m: 31, xl: 37 }}>
                                <Text mb={0} fontWeight='bold' >{props.firstColumnHeading.value}</Text>
                            </Flex>
                        </Flex>

                        <StyledTableHeader scope='col'>
                            <Text mb={0} fontWeight='bold'>{props.secondColumnHeading.value}</Text>
                        </StyledTableHeader>
                        <StyledTableHeader scope='col'>
                            <Text mb={0} fontWeight='bold'>{props.thirdColumnHeading.value}</Text>
                        </StyledTableHeader>
                    </Flex>
                }
                {props.items.map((item, index) => (
                    <Flex
                        as="tr"
                        w={1}
                        px={1}
                        py={2}
                        key={index}
                        justifyContent='space-between'
                        backgroundColor={index % 2 === 0 ? 'blue11' : 'white'}
                    >
                        <Flex as="td" w={1}>
                            <Flex w={1} maxw={{ _: 25, m: 31, xl: 37 }}>
                                <Text variant='paragraph-14' mb={0} aria-label={`
                                ${item.name} 
                                ${item.isPro ? props.screenReaderTextColumn1?.value : ''} 
                                ${item.isCon ? props.screenReaderTextColumn2?.value : ''}`} >{item.name}</Text>

                            </Flex>
                        </Flex>
                        <StyledTableCell>
                            {item.isPro &&
                                <Flex mb={0} alignItems='center' aria-label='Check'>
                                    <Icon icon='check-solid'></Icon>
                                </Flex>
                            }
                        </StyledTableCell>
                        <StyledTableCell>
                            {item.isCon &&
                                <Flex mb={0} alignItems='center' aria-label='Check'>
                                    <Icon icon='check-solid'></Icon>
                                </Flex>
                            }
                        </StyledTableCell>
                    </Flex>
                ))}
            </Flex>
        </BlockCommonLayout>
    )
}

export { ProsAndConsBlock }